import BAboutFirstBlock from './BAboutFirstBlock'

export default BAboutFirstBlock
